import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";
import Div100vh from "react-div-100vh/lib/Div100vh";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import store from "../../helpers/store/Store";
import {
  getSelectedModel,
  getSelectedModelArray,
} from "../../helpers/actions/Action";

const WorkFlowPanel = () => {
  const animatedComponents = makeAnimated();
  //Loaded State
  const userData = useSelector((state) => state.requestUserDataReducer.data);
  const selectedProject = useSelector(
    (state) => state.getSelectedProjectReducer.data
  );

  // const selectedItem = useSelector(
  //   (state) => state.getModelArrayReducer.data.find(o=>o.selected==true)
  // );

  const selectedItem = useSelector((state) =>
    state.getSelectedModelReducer.data
  );

  //Local State
  const [userDropDownData, setUserDropDownData] = useState();
  const [selectedReviewers, setSelectedReviewers] = useState();
  const [selectedApprovers, setSelectedApprovers] = useState();
  const [uploudFolderId, setUploadFolderId] = useState();
  const [uploudFolderName, setUploadFolderName] = useState(
    "Please Select A Folder"
  );
  const [targetSuitability, setTargetSuitability] = useState();
  const [comment, setComment] = useState();
  const [folderStructure, setFolderStructure] = useState();
  const [folders, setFolders] = useState();
  const [uploadFile, setUploadFile] = useState();
  const [uploadFileName, setUploadFileName] = useState();

  //-------------- On Load --------------------------------------
  //When Project Selected Load BimUsers and arrange for dropdown
  useEffect(() => {
    if (!selectedProject.projectid) {
      return;
    }
    console.log("selectedProject", selectedProject);
    setFolders({});
    axios({
      method: "Get",
      url:
        HOST_URL +
        "/api/forge/bim360/Users?projectid=" +
        selectedProject.projectid,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        var tempData = [];
        response.data.results.forEach((user) => {
          var user = {
            value: `${user.autodeskId}-${user.email}-${user.firstName} ${user.lastName}`,
            label: `${user.firstName} ${user.lastName} - ${user.email}`,
          };
          tempData.push(user);
        });
        console.log("Users -", tempData);
        setUserDropDownData(tempData);
      })
      .catch((error) => {
        console.log(error);
      });

    axios({
      method: "Get",
      // method: "Put",
      url:
        HOST_URL +
        "/api/workflow/structure?projectId=" +
        selectedProject.projectid,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        console.log("FolderStructure -", response.data);
        setFolderStructure(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedProject]);

  //---------------- Api Calls -----------------
  const handleSubmitButtonClick = () => {
    if (
      selectedReviewers == null ||
      selectedApprovers == null ||
      uploudFolderId == null
    ) {
      alert(
        "Please ensure Reviewers, Approves and a Target folder is provided"
      );
      return;
    }
    var userEmail = userDropDownData
      .find((o) => o.value.includes(userData.id))
      .value.split("-")[1];
    debugger;
    var hrefSplit = selectedItem.hrefbim360.split("/");
    var urn = hrefSplit[hrefSplit.length - 1];
    const workflow = {
      projectId: String(selectedProject.projectid),
      documentId: urn,
      createdByUserId: userData.id,
      comment: comment,
      reviewers: selectedReviewers,
      approvers: selectedApprovers,
      suitability: "Current Suitability",
      targetSuitability: targetSuitability,
      documentName: selectedItem.fileName,
      itemId: selectedItem.id,
      uploadFolderId: uploudFolderId,
      createdByEmail: userEmail,
      uploadFolderName: uploudFolderName,
      projectName: String(selectedProject.text),
    };

    let formData = new FormData();
    formData.append("formData", JSON.stringify(workflow));
    for (const value of formData.values()) {
      console.log("formData", value);
    }
    debugger;
    axios({
      method: "post",
      url: HOST_URL + "/api/workflow",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    })
      .then((response) => {
        console.log("response =", response);
        alert("Workflow has been submitted");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleUploadButtonClick = () => {
    const upload = {
      projectId: String(selectedProject.projectid),
      createdByUserId: userData.id,
      uploadFolderId: uploudFolderId,
    };

    let formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("formData", JSON.stringify(upload));

    debugger;
    axios({
      method: "post",
      url: HOST_URL + "/api/workflow/upload",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    })
      .then((response) => {
        console.log("response =", response);
        alert("File had been uploaded");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleMoveButtonClick = () => {
    //Do Delete
    var hrefSplit = selectedItem.hrefbim360.split("/");
    var urn = hrefSplit[hrefSplit.length - 1];
    const uploadCopy = {
      projectId: String(selectedProject.projectid),
      documentId: urn,
      itemId: selectedItem.id,
      uploadFolderId: uploudFolderId,
    };
    let formData = new FormData();
    formData.append("formData", JSON.stringify(uploadCopy));
    axios({
      method: "post",
      url: HOST_URL + "/api/workflow/uploadCopy",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    })
      .then((response) => {
        console.log("File Copied");
        let formData = new FormData();
        formData.append("projectId", selectedProject.projectid);
        formData.append("urnId", urn);

        axios({
          method: "post",
          url: HOST_URL + "/api/workflow/delete",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        })
          .then((response) => {
            debugger;
            store.dispatch(getSelectedModel(""));
            store.dispatch(getSelectedModelArray([]));
            alert("File has been moved");
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDeleteButtonClick = () => {
    var hrefSplit = selectedItem.hrefbim360.split("/");
    var urnId = hrefSplit[hrefSplit.length - 1];

    let formData = new FormData();
    formData.append("projectId", selectedProject.projectid);
    formData.append("urnId", urnId);

    debugger;
    axios({
      method: "post",
      url: HOST_URL + "/api/workflow/delete",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    })
      .then((response) => {
        alert("File has been deleted");
        store.dispatch(getSelectedModel(""));
        store.dispatch(getSelectedModelArray([]));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleRefreshButtonClick = () => {
    axios({
      method: "put",
      url:
        HOST_URL +
        "/api/workflow/structure?projectId=" +
        selectedProject.projectid,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        console.log("FolderStructure -", response.data);
        setFolderStructure(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //---------------------- Input Handlers --------------------------
  const commentInputHandler = (e) => {
    setComment(e.target.value);
  };
  const targetSuitabilityInputHandler = (e) => {
    setTargetSuitability(e.target.value);
  };
  const uploudFolderIdInputHandler = (id, name) => {
    setUploadFolderId(id);
    setUploadFolderName(name);
  };
  const uploadFileInputHandler = (e) => {
    setUploadFile(e.currentTarget.files[0]);
    setUploadFileName(e.currentTarget.files[0].name);
    console.log(e.currentTarget.files[0]);
  };

  const reviewerInputHandler = (e) => {
    var tempData = [];
    if (e) {
      e.forEach((user) => {
        tempData.push(user.value);
      });
    }
    setSelectedReviewers(tempData);
  };

  const approverInputHandler = (e) => {
    var tempData = [];
    if (e) {
      e.forEach((user) => {
        tempData.push(user.value);
      });
    }
    setSelectedApprovers(tempData);
  };

  function recurseFolders(folder, id) {
    for (var i = 0, count = folder.NestedObjects.length; i < count; i++) {
      if (folder.NestedObjects[i].Id == id) {
        folder.NestedObjects[i].Active = true;
      } else {
        recurseFolders(folder.NestedObjects[i]);
      }
    }
  }

  const updateFolderStructure = (e, folder) => {
    setFolderStructure(folderStructure);
  };

  // --------------------- Renders -------------------------
  const renderStructure = (folder, index, folderOnly = false) => {
    return (
      <div className="mb-1">
        <p
          className={
            folder.NestedObjects.filter((f) => {
              return (
                (folderOnly == true && f.Type.includes("folder")) ||
                folderOnly == false
              );
            }).length == 0
              ? "pl-5 mb-1"
              : "mb-1"
          }>
          {folder.NestedObjects.filter((f) => {
            return (
              (folderOnly == true && f.Type.includes("folder")) ||
              folderOnly == false
            );
          }).length > 0 ? (
            <i
              style={{ cursor: "pointer" }}
              data-toggle="collapse"
              data-target={"#collapse" + index}
              onClick={(e) => updateFolderStructure(e, folder)}
              className="icon icon-folder"></i>
          ) : (
            <></>
          )}
          <button
            className={
              uploudFolderId == folder.Id
                ? "btn p-1 btn-info"
                : "btn p-1 btn-secondary"
            }
            onClick={() => uploudFolderIdInputHandler(folder.Id, folder.Name)}>
            {folder.Name}
          </button>
        </p>

        <div
          className={index == 0 ? "collapse show" : "collapse"}
          id={"collapse" + index}>
          <div className="pl-4">
            {folder.NestedObjects?.map((f, i) => {
              if (
                (folderOnly == true && f.Type.includes("folder")) ||
                folderOnly == false
              ) {
                return renderStructure(f, index + 1 + "" + i, folderOnly);
              }
            })}
          </div>
        </div>
      </div>
    );
  };

  //-------------------------- Final Render -------------------------------

  return selectedItem != null ? (
    <div>
      <ul class="nav nav-tabs">
        <li class="active">
          <a data-toggle="tab" href="#workflow">
            Review
          </a>
        </li>

        <li>
          <a data-toggle="tab" href="#move">
            Move
          </a>
        </li>
        <li>
          <a data-toggle="tab" href="#delete">
            Delete
          </a>
        </li>
        <li>
          <a data-toggle="tab" href="#upload">
            Upload
          </a>
        </li>
      </ul>
      {/* Tabs */}
      <div class="tab-content">
        {/* Workflow------------------------------------------------------------------------------ */}
        <div id="workflow" class="tab-pane fade active mb-1 mt-1 show">
          <h3>Submit For Review</h3>
          <div className="row mt-2">
            <div className="col-3">
              <label>Current Document</label>
            </div>
            <div className="col">
              <input
                className="form-control"
                type="text"
                id="workflowInput"
                placeholder={selectedItem.fileName}
                disabled
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3">
              <label>Project</label>
            </div>
            <div className="col">
              {
                <input
                  className="form-control"
                  type="text"
                  id="workflowInput"
                  placeholder={selectedProject.text}
                  disabled
                />
              }
            </div>
          </div>
          {/* Maybe do a boostrap Breadcrumb */}
          <div className="row mt-2">
            <div className="col-3">
              <label>Target Folder</label>
            </div>
            <div className="col">
              <input
                className="form-control"
                type="text"
                id="workflowInput"
                placeholder={uploudFolderName}
                disabled
              />
            </div>
          </div>
          {folderStructure != null ? (
            <div className="mt-2">
              <div className="card border border-secondary rounded p-2">
                <div
                  className="overflow-auto"
                  style={{ maxHeight: "400px", minHeight: "400px" }}>
                  {renderStructure(folderStructure.structure, 0, true)}
                </div>
                <div className="text-right">
                  <button
                    className="btn btn-primary"
                    onClick={handleRefreshButtonClick}>
                    Refresh Data - {folderStructure.lastUpdated}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <p>Loading Structure....</p>
          )}

          <div className="row mt-2">
            <div className="col-2">
              <label>Reviewers</label>
            </div>
            <div className="col">
              <Select
                closeMenuOnSelect={false}
                components={animatedComponents}
                defaultValue={[]}
                isMulti
                options={userDropDownData}
                onChange={reviewerInputHandler}
              />
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-2">
              <label>Approvers</label>
            </div>
            <div className="col">
              <Select
                closeMenuOnSelect={false}
                components={animatedComponents}
                defaultValue={[]}
                isMulti
                options={userDropDownData}
                onChange={approverInputHandler}
              />
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-2">
              <label>Comment</label>
            </div>
            <div className="col">
              <textarea
                className="form-control"
                type="text"
                id="workflowInput"
                placeholder="Comment"
                onChange={commentInputHandler}
              />
            </div>
          </div>

          <div className="text-right mt-2">
            <button
              className="btn btn-success"
              onClick={handleSubmitButtonClick}>
              Submit
            </button>
          </div>
        </div>
        {/* Upload------------------------------------------------------------------------------ */}

        <div id="upload" class="tab-pane fade mb-1 mt-1">
          <h3>Upload Document</h3>
          <div className="row mt-2">
            <div className="col-3">
              <label>Choose Document</label>
            </div>
            <div className="col">
              <div class="file-browser input-group">
                <label class="input-group-prepend input-group-btn">
                  <span class="btn btn-primary">
                    Browse{" "}
                    <input
                      type="file"
                      class="d-none"
                      multiple=""
                      onChange={uploadFileInputHandler}
                    />
                  </span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  readonly=""
                  placeholder={uploadFileName}
                />
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3">
              <label>Project</label>
            </div>
            <div className="col">
              {
                <input
                  className="form-control"
                  type="text"
                  id="workflowInput"
                  placeholder={selectedProject.text}
                  disabled
                />
              }
            </div>
          </div>
          {/* Maybe do a boostrap Breadcrumb */}
          <div className="row mt-2">
            <div className="col-3">
              <label>Target Folder</label>
            </div>
            <div className="col">
              <input
                className="form-control"
                type="text"
                id="workflowInput"
                placeholder={uploudFolderName}
                disabled
              />
            </div>
          </div>
          {folderStructure != null ? (
            <div className="mt-2">
              <div className="card border border-secondary rounded p-2">
                <div
                  className="overflow-auto"
                  style={{ maxHeight: "400px", minHeight: "400px" }}>
                  {renderStructure(folderStructure.structure, 0, true)}
                </div>
                <div className="text-right">
                  <button
                    className="btn btn-primary"
                    onClick={handleRefreshButtonClick}>
                    Refresh Data - {folderStructure.lastUpdated}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <p>Loading Structure....</p>
          )}
          <div className="text-right mt-2">
            <button
              className="btn btn-success"
              onClick={handleUploadButtonClick}>
              Upload
            </button>
          </div>
        </div>
        {/* Move------------------------------------------------------------------------------ */}
        <div id="move" class="tab-pane fade">
          <h3>Move Document</h3>
          <div className="row mt-2">
            <div className="col-3">
              <label>Current Document</label>
            </div>
            <div className="col">
              <input
                className="form-control"
                type="text"
                id="workflowInput"
                placeholder={selectedItem.fileName}
                disabled
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3">
              <label>Project</label>
            </div>
            <div className="col">
              {
                <input
                  className="form-control"
                  type="text"
                  id="workflowInput"
                  placeholder={selectedProject.text}
                  disabled
                />
              }
            </div>
          </div>
          {/* Maybe do a boostrap Breadcrumb */}
          <div className="row mt-2">
            <div className="col-3">
              <label>Target Folder</label>
            </div>
            <div className="col">
              <input
                className="form-control"
                type="text"
                id="workflowInput"
                placeholder={uploudFolderName}
                disabled
              />
            </div>
          </div>
          {folderStructure != null ? (
            <div className="mt-2">
              <div className="card border border-secondary rounded p-2">
                <div
                  className="overflow-auto"
                  style={{ maxHeight: "400px", minHeight: "400px" }}>
                  {renderStructure(folderStructure.structure, 0, true)}
                </div>
                <div className="text-right">
                  <button
                    className="btn btn-primary"
                    onClick={handleRefreshButtonClick}>
                    Refresh Data - {folderStructure.lastUpdated}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <p>Loading Structure....</p>
          )}
          <div className="text-right mt-2">
            <button className="btn btn-success" onClick={handleMoveButtonClick}>
              Move
            </button>
          </div>
        </div>
        {/* Delete------------------------------------------------------------------------------ */}
        <div id="delete" class="tab-pane fade">
          <h3>Delete Document</h3>
          <div className="row mt-2">
            <div className="col-3">
              <label>Current Document</label>
            </div>
            <div className="col">
              <input
                className="form-control"
                type="text"
                id="workflowInput"
                placeholder={selectedItem.fileName}
                disabled
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-3">
              <label>Project</label>
            </div>
            <div className="col">
              {
                <input
                  className="form-control"
                  type="text"
                  id="workflowInput"
                  placeholder={selectedProject.text}
                  disabled
                />
              }
            </div>
          </div>
          <div className="text-right mt-2">
            <button
              className="btn btn-success"
              onClick={handleDeleteButtonClick}>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default WorkFlowPanel;
